import React, { useEffect, useState } from 'react'

import { Link } from 'react-router-dom';
import Header from '../component/Header';


export default function Plans(props) {

    const [plans, setPlans] = useState('Platinum');
    const [price, setPrice] = useState('149');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>
            <Header />
            <div className='plan-page-section'>
                <section className='banner-section-about top banner-section-about_plan bottom p-l-r'>
                    <div className='about-banner-content about-banner-content_new'>
                        {/* <img src={require('../assets/images/frame1.png')} /> */}
                        <h1 className='about-page-heading'>
                            Embark on a transformative journey with The Beyond Lifestyle
                        </h1>
                    </div>
                </section>
                <section className='plan-section-box p-l-r'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-lg-6'>
                                <div className='left-section'>
                                    <h3>Free For <br /><span>7 Days</span></h3>
                                    <ul>
                                        <li>
                                            <div className='list-plan-pack'>
                                                <span><i class="fa-solid fa-check"></i></span><p>Get All In app Access and Step into the Wellness Sanctuary.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='list-plan-pack'>
                                                <span><i class="fa-solid fa-check"></i></span><p>Enjoy Premium Entry to Exclusive Podcasts and Live Sessions.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='list-plan-pack'>
                                                <span><i class="fa-solid fa-check"></i></span><p>Align a Free Talk To Me Session with an Expert</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='list-plan-pack'>
                                                <span><i class="fa-solid fa-check"></i></span><p>We’ll send you an email reminder before your trial ends. Cancel Anytime</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='list-plan-pack'>
                                                <span><i class="fa-solid fa-check"></i></span><p>Enjoy Access To The Know Your Self Psychometric Test</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <div className='right-section' id='download'>
                                    <div className='form-box-right'>
                                        <form>
                                            <h4>Download Now</h4>
                                            {/* <div className='input-box'>
                                            <input type='email' placeholder='Enter your email' />
                                        </div>
                                        <p className='paragraph'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> */}
                                            <div class="download-box">
                                                <a href="https://apps.apple.com/in/app/the-beyond-lifestyle/id6478144849" target="_blank">
                                                    <img src={require('../assets/images/apple.png')} alt="iOS App Download" />
                                                </a>
                                                <a href="https://play.google.com/store/apps/details?id=com.tblstyle" target="_blank">
                                                    <img src={require('../assets/images/android.png')} alt="iOS App Download" />
                                                </a>
                                            </div>
                                            {/* <button className='common_btn'>Get Started<i class="fa-solid fa-arrow-right"></i></button> */}
                                            <p className='paragraph mt-4 pt-0'>By getting started. you agree to our <Link to='/terms-and-conditions'>Terms of Use</Link> and <Link to='/privacy-policy'>Privacy Policy</Link></p>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <section className='premium-plans-section top bottom'>
                <div class="container-fluid">
                    <div class="row justify-content-center">
                        {/* <div className='col-lg-6'>
                            <div className='left-section'>
                                <img src={require('../../assets/images/plans.png')} />
                            </div>
                        </div> */}
                        <div class="col-lg-7">
                            <h3>Start your free trial of<br /> The Beyond Lifestyle Premium</h3>
                            <div className='plans-section-box'>
                                <ul>
                                    <li className={plans == 'Platinum' ? 'active' : ''} onClick={() => { setPlans('Platinum'); setPrice('149') }}>
                                        <h4>Platinum</h4>
                                        <p>365 Days</p>
                                        <h6>$149</h6>
                                        <span>
                                            7-Day Free Trial
                                            <div className='active_icon'>
                                                <i class="fa-solid fa-check"></i>
                                            </div>
                                        </span>

                                    </li>
                                    <li className={plans == 'Silver' ? 'active' : ''} onClick={() => { setPlans('Silver'); setPrice('49.99') }}>
                                        <h4>Silver</h4>
                                        <p>90 Days</p>
                                        <h6>$49.99</h6>
                                        <span>7-Day Free Trial

                                            <div className='active_icon'>
                                                <i class="fa-solid fa-check"></i>
                                            </div>
                                        </span>

                                    </li>
                                </ul>
                                <div className='plans-tagline'>
                                    After your free trial, the {price == '149' ? '365' : '90'}-days subscription is <strong>${price}</strong> and automatically renews {price == '149' ? 'each year' : 'quarterly'} until cancelled.
                                    {/* After your free trial, the yearly subscription is $49.99 and automatically renews quarterly until cancelled. */}
                                </div>
                                <button>
                                <Link to={'/plans#download'}>Download App</Link>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='plan-chart-box p-l-r top bottom'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='plan-chart-section'>
                                <ul>
                                    <li className='header-chart'>
                                        <div className='left-section'>
                                            <h3 className='text-chart-title'>What’s Included</h3>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-heading'>
                                                <h3>Free User</h3>
                                            </div>
                                            <div className='type-user-heading'>
                                                <h3>Paid User</h3>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Profile Creation</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Themes</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Today’s Quote</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Harmonies</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Community</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Wellness Tunes</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Live Session</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p className='show'>Priority Access- Questions would surely be asked</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Know Yourself</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Meditation</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Healthy Habits</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Kids Wellness</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Wellbeing</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Astro Live </h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Lifestyle Practices </h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Breathe </h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Daily Yoga </h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>My Diary </h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Podcast </h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Talk To Me </h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Become a Podcaster </h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Wellness Curated Online Sessions</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Community Event</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className='body-chart'>
                                        <div className='left-section'>
                                            <h5>Gratitude Gifts</h5>
                                        </div>
                                        <div className='right-section'>
                                            <div className='type-user-tag'>
                                                <p>Free User</p>
                                                <span className='inactive'><i class="fa-solid fa-minus"></i></span>
                                            </div>
                                            <div className='type-user-tag'>
                                                <p>Subscribed User</p>
                                                <span className='active'><i class="fa-solid fa-check"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}
